// extracted by mini-css-extract-plugin
export var container = "styles-module__container___dDRZv";
export var description = "styles-module__description___Pv3Vq";
export var header = "styles-module__header___HTV_V";
export var imgContainer = "styles-module__imgContainer___rZNi5";
export var leftImg = "styles-module__leftImg___ewAKR";
export var middleImg = "styles-module__middleImg___ICZau";
export var rightImg = "styles-module__rightImg___sAGNT";
export var textContainer = "styles-module__textContainer___xk6vM";